import { AppBar, Box, Grid, Toolbar } from "@mui/material";
import React, { useEffect } from "react";
import Typo from "../typo/Typo";
import {
  APPBAR_STYLES,
  GREETING_TXT_STYLE,
  HEADER_GRID_LANG_STYLE,
  HEADER_GRID_STYLE,
  HEADER_STYLE,
  HEIGHT_45,
  LANG_LABEL_STYLE,
  LANG_LIST_STYLE,
  LANG_ENG,
  MAIN_HEADING,
  MARGIN_P_0,
  POS_RELATIVE,
  USER_ICON_LIST_STYLE,
  USER_ICON_STYLE,
  WIDTH_100,
  LANG_FRENCH,
  LANG_SPANISH,
} from "../../../utils/GlobalConstants";
import "./Header.css";
import logo from "../../../assets/images/logo.png";
import userIco from "../../../assets/images/user-icon.svg";
import ArrowDropDownCircleIcon from "@mui/icons-material/ArrowDropDownCircle";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { authConfig } from "../../../views/auth/Config";
import Loader from "../../common/dialog/Loader";

const Header = () => {
  const { i18n, t } = useTranslation();
  const [defaultLang, setDefaultLang] = React.useState("English");
  const [show, setshow] = React.useState(false);
  const [showprofile, setshowprofile] = React.useState(false);
  const [username, setusername] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const name = useSelector((state) => state?.HandleLogin?.handleName);

  useEffect(() => {
    if (name) {
      setusername(name);
      localStorage.setItem("username", name);
    } else {
      const storedName = localStorage.getItem("username");
      if (storedName) {
        setusername(storedName);
      }
    }
  }, [name]);

  const onLogOut = () => {
    window.location.replace(
      // `${authConfig.ssoUrl}/${authConfig.tenantId}/logout`
      `${authConfig.ssoUrl}/logout`
    );
    document.cookie = "";
    Cookies.remove("access_token");
    Cookies.remove("username");
    // Cookies.remove('d_12');
    localStorage.removeItem("username");
    setusername("")
    window.location.href = "/fleet/login";
  };

  function changeLanguage(lang, selection) {
    updateUserPref(lang, selection);
  }

  const updateUserPref = async (lang, selection) => {
    setIsLoading(true);
    try {
      i18n.changeLanguage(lang);
      setDefaultLang(selection);
      setIsLoading(false);
    } catch (e) {
      console.log(e);
      setIsLoading(false);
    }
  };

  return (
    <AppBar position="fixed" sx={APPBAR_STYLES}>
      <Toolbar sx={MARGIN_P_0}>
        <Grid container sx={WIDTH_100} alignItems="center">
          <Grid item md={6} sm={6} lg={6} xs={6} sx={HEADER_GRID_STYLE}>
            <Box component="img" sx={HEIGHT_45} alt="Your logo." src={logo} />
            <Typo text={MAIN_HEADING} style={HEADER_STYLE} />
          </Grid>
          <Grid item md={6} sm={6} lg={6} xs={6} sx={HEADER_GRID_LANG_STYLE}>
            <div
              className="defLang"
              testid="lang"
              onClick={() => {
                setshow(!show);
              }}
              style={LANG_LABEL_STYLE}
            >
              <span>{defaultLang}</span>&nbsp;
              <div>
                <ArrowDropDownCircleIcon />
              </div>
              {show && (
                <div style={LANG_LIST_STYLE}>
                  <div
                    className="lang"
                    testid="en"
                    onClick={() => changeLanguage("en", LANG_ENG)}
                  >
                    {LANG_ENG}
                  </div>
                  <div
                    className="lang"
                    testid="fr"
                    onClick={() => changeLanguage("fr", LANG_FRENCH)}
                  >
                    {LANG_FRENCH}
                  </div>
                  <div
                    className="lang"
                    testid="es"
                    onClick={() => changeLanguage("es", LANG_SPANISH)}
                  >
                    {LANG_SPANISH}
                  </div>
                </div>
              )}
            </div>

            {username && (
              <>
                <div style={GREETING_TXT_STYLE}>
                  {t("header.Welcome")}, {username}
                </div>
              </>
            )}
            <div style={POS_RELATIVE}>
              <Box
                component="img"
                sx={USER_ICON_STYLE}
                testid="profile"
                alt="Your logo."
                src={userIco}
                onClick={() => {
                  setshowprofile(!showprofile);
                }}
              />
              {showprofile && (
                <div style={USER_ICON_LIST_STYLE}>
                  <div
                    testid="logout"
                    className="lang"
                    onClick={() => {
                      onLogOut();
                    }}
                  >
                    {t("header.Logout")}
                  </div>
                </div>
              )}
            </div>
          </Grid>
        </Grid>
        {isLoading && (
          <Loader data-testid="loading-sppiner-id" className="Loader-style" />
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
